
  <div class="col-sm-12">
      <ejs-accordion #productsAccordion expandMode='Single' *ngIf="products.length > 0" (expanding)="expanding($event)" (created)="accordionCreated($event)" class='nested-accordion'>
          <e-accordionitems>
              <e-accordionitem *ngFor="let product of products; let prodIdx = index">

                <div class="col-sm-12">
                  <ng-template #header>
                      <div class="row">
                        <div class="col-sm-12 sidebar-item-div">
                          <span id="proprietaryName" tabindex="0" aria-label="proprietary name"> Proprietary Name</span>
                        </div>

                        <div class="col-sm-12 sidebar-item-div product-name">
                          <ejs-tooltip id="tooltipObj" #tooltipObj opensOn='custom' content=''
                                       [enableHtmlParse]="false" class="proprietary-name-tooltip">

                            <span class='tooltip-span' (mouseenter)="showSFToolTip($event);"
                                  (mouseleave)="hideSFToolTip($event);" tabindex="0" [attr.aria-label]="decodeHtml(product.proprietaryName) + ' ' + product.ndcProductCode">
                              {{ decodeHtml(product.proprietaryName)}}
                              ({{product.ndcProductCode}})
                            </span>
                          </ejs-tooltip>
                        </div>
                      </div>
                 
                  </ng-template>

                  <ng-template #content>
                    <div class="sidebar-form-sections-div" *ngIf="isKit() && !isPart">
                      <ul class="list-unstyled" role="list">
                        <li role="listitem">
                          <a href="javascript:void(0);" (click)="scrollToElement('#productDetail')"
                             tabindex="0" role="link" aria-label="product details" (keydown.enter)="scrollToElement('#productDetail')">Product Details</a>
                        </li>
                        <li role="listitem">
                          <a href="javascript:void(0);" (click)="scrollToElement('#productInfo')"
                             tabindex="0" role="link" aria-label="product information" (keydown.enter)="scrollToElement('#productInfo')">Product Information</a>
                        </li>
                        <li role="listitem">
                          <a href="javascript:void(0);" (click)="scrollToElement('#packaging')"
                             tabindex="0" role="link" aria-label="packaging" (keydown.enter)="scrollToElement('#packaging')">Packaging</a>
                        </li>
                        <li role="listitem">
                          <a href="javascript:void(0);" (click)="scrollToElement('#marketing')"
                             tabindex="0" role="link" aria-label="marketing information" (keydown.enter)="scrollToElement('#marketing')">Marketing Information</a>
                        </li>
                        <li *ngIf="isKit()" role="listitem">
                          <a href="javascript:void(0);" (click)="scrollToElement('#quantityParts')"
                             tabindex="0" role="link" aria-label="quantity of parts" (keydown.enter)="scrollToElement('#quantityParts')">Quantity of Parts</a>
                        </li>
                      </ul>
                    </div>
                    <div *ngFor="let part of product['parts']; let partIdx = index">

                      <ejs-tooltip id="tooltipObjPart" #tooltipObjPart opensOn='custom' content='' [enableHtmlParse]="false">

                        <div id="part-{{prodIdx}}-{{partIdx}}" class="sidebar-sub-item-div part-name" (click)="showPart(partIdx)" tabindex="0" (keydown.enter)="showPart(partIdx)">
                          <span tabindex="0" class='tooltip-span' (mouseenter)="showSFToolTipPart($event);" (mouseleave)="hideSFToolTipPart($event);">Part {{partIdx + 1}} - {{ decodeHtml(products[prodIdx]['parts'][partIdx].proprietaryName)}}</span>
                        </div>
                      </ejs-tooltip>

                      <div class=" col-sm-offset-1 sidebar-form-sections-div" *ngIf="currentPartIndex >= 0">
                        <ul class="list-unstyled" role="list">
                          <li role="listitem">
                            <a href="javascript:void(0);" (click)="showPart(partIdx);scrollToElement('#productDetail')"
                               tabindex="0" role="link" aria-label="Product Details" (keydown.enter)="scrollToElement('#productDetail')">Product Details</a>
                          </li>
                          <li role="listitem">
                            <a href="javascript:void(0);" (click)="showPart(partIdx);scrollToElement('#productInfo')"
                               tabindex="0" role="link" aria-label="Product Information" (keydown.enter)="scrollToElement('#productInfo')">Product Information</a>
                          </li>
                          <li role="listitem">
                            <a href="javascript:void(0);" (click)="showPart(partIdx);scrollToElement('#activeIngred')"
                               tabindex="0" role="link" aria-label="Active Ingredients / Active Moiety" (keydown.enter)="scrollToElement('#activeIngred')">Active Ingredients / Active Moiety</a>
                          </li>
                          <li role="listitem">
                            <a href="javascript:void(0);" (click)="showPart(partIdx);scrollToElement('#inactiveIngred')"
                               tabindex="0" role="link" aria-label="Inactive Ingredients" (keydown.enter)="scrollToElement('#inactiveIngred')">Inactive Ingredients</a>
                          </li>
                          <li role="listitem">
                            <a href="javascript:void(0);" (click)="showPart(partIdx);scrollToElement('#productChars')"
                               tabindex="0" role="link" aria-label="Product Characteristics" (keydown.enter)="scrollToElement('#productChars')">Product Characteristics</a>
                          </li>
                          <li role="listitem">
                            <a href="javascript:void(0);" (click)="showPart(partIdx);scrollToElement('#packaging')"
                               tabindex="0" role="link" aria-label="Packaging" (keydown.enter)="scrollToElement('#packaging')">Packaging</a>
                          </li>
                          <li role="listitem">
                            <a href="javascript:void(0);" (click)="showPart(partIdx);scrollToElement('#marketing')"
                               tabindex="0" role="link" aria-label="Marketing Information" (keydown.enter)="scrollToElement('#marketing')">Marketing Information</a>
                          </li>
                        </ul>
                      </div>

                    </div>

                    <div class="sidebar-form-sections-div" *ngIf="!isKit()">
                      <ul class="list-unstyled" role="list">
                        <li role="listitem">
                          <a href="javascript:void(0);" (click)="scrollToElement('#productDetail')"
                             tabindex="0" role="link" aria-label="Product Details" (keydown.enter)="scrollToElement('#productDetail')">Product Details</a>
                        </li>
                        <li role="listitem">
                          <a href="javascript:void(0);" (click)="scrollToElement('#productInfo')"
                             tabindex="0" role="link" aria-label="Product Information" (keydown.enter)="scrollToElement('#productInfo')">Product Information</a>
                        </li>
                        <li role="listitem">
                          <a href="javascript:void(0);" (click)="scrollToElement('#activeIngred')"
                             tabindex="0" role="link" aria-label="Active Ingredients / Active Moiety" (keydown.enter)="scrollToElement('#activeIngred')">Active Ingredients / Active Moiety</a>
                        </li>
                        <li role="listitem">
                          <a href="javascript:void(0);" (click)="scrollToElement('#inactiveIngred')"
                             tabindex="0" role="link" aria-label="Inactive Ingredients" (keydown.enter)="scrollToElement('#inactiveIngred')">Inactive Ingredients</a>
                        </li>
                        <li role="listitem">
                          <a href="javascript:void(0);" (click)="scrollToElement('#productChars')"
                             tabindex="0" role="link" aria-label="Product Characteristics" (keydown.enter)="scrollToElement('#productChars')">Product Characteristics</a>
                        </li>
                        <li role="listitem">
                          <a href="javascript:void(0);" (click)="scrollToElement('#packaging')"
                             tabindex="0" role="link" aria-label="Packaging" (keydown.enter)="scrollToElement('#packaging')">Packaging</a>
                        </li>
                        <li role="listitem">
                          <a href="javascript:void(0);" (click)="scrollToElement('#marketing')"
                             tabindex="0" role="link" aria-label="Marketing Information" (keydown.enter)="scrollToElement('#marketing')">Marketing Information</a>
                        </li>
                      </ul>
                    </div>

                    <div class="row product-menu">
                      <div class="col-sm-6" *ngIf="!product['parts']">
                        <a id='clone-product-{{prodIdx}}' href="javascript:void(0);" (click)="cloneProduct()" *ngIf="!product['parts']"
                           tabindex="0" role="link" aria-label="clone product" (keydown.enter)="cloneProduct()"><i class="fas fa-clone"></i>clone product</a>
                      </div>
                      <div class="col-sm-6" *ngIf="!product['parts']">
                        <a href="javascript:void(0);" (click)='deleteProduct(prodIdx)' id='delete-product-{{prodIdx}}' class='delete-link'>
                          <i class="fas fa-trash" aria-hidden="true"
                             tabindex="0" role="link" aria-label="delete product" (keydown.enter)="deleteProduct(prodIdx)"></i>delete product
                        </a>
                      </div>
                      <div class="col-sm-6" *ngIf="product['parts']">
                        <a id='clone-kit-{{prodIdx}}' href="javascript:void(0);" (click)='cloneProduct(prodIdx)'
                           tabindex="0" role="link" aria-label="clone kit" (keydown.enter)="cloneProduct(prodIdx)"><i class="fas fa-clone" aria-hidden="true"></i>clone kit</a>
                      </div>
                      <div class="col-sm-6" *ngIf="product['parts']">
                        <a id='delete-kit-{{prodIdx}}' href="javascript:void(0);" (click)='deleteProduct(prodIdx)'
                           tabindex="0" role="link" aria-label="delete kit" (keydown.enter)="deleteProduct(prodIdx)"><i class="fas fa-trash" aria-hidden="true"></i>delete kit</a>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </e-accordionitem>
          </e-accordionitems>
      </ejs-accordion>
  </div>

<ejs-dialog #sbModalDialog [isModal]='isModal' [width]='sbmodalValWidth' [buttons]='buttons' [animationSettings]='animationSettings'  [visible]='sbmodalValHidden' (overlayClick)="onOverlayClick()" [closeOnEscape]='true' [hidden]='!sbmodalValVisible' [height]='sbmodalValHeight'>
<div class="card">
  <div class="card-header bg-primary">
      <h3 class="card-title text-white" tabindex="0" role="heading" aria-label="remove products or kits" aria-level="3">Remove Products/Kits</h3>
  </div>
  <div class="card-body" tabindex="0">
    Last Product/Kit cannot be deleted.
    Revision must have at least one Product/Kit.
  </div>
</div>
</ejs-dialog>

<ejs-dialog #confirmDeleteDialog [isModal]='isModal' [buttons]='confirmDeleteDlgButtons' [visible]='sbmodalValHidden'
[position]='position' [animationSettings]='animationSettings' [width]='sbmodalValWidth'  (overlayClick)="onOverlayDeleteDlgClick()">
<ng-template #content>
  <div class="card">
    <div class="card-header bg-primary">
        <h3 class="card-title text-white" tabindex="0" role="heading" aria-level="3" [attr.aria-label]="'Delete ' + isKit() ? 'Kit' : 'Product'">Delete {{ isKit() ? 'Kit' : 'Product'}} ?</h3>
    </div>
    <div class="card-body" tabindex="0">
      Are you sure you want to delete this {{isKit() ? 'Kit' : 'Product'}}?
    </div>
  </div>
</ng-template>
</ejs-dialog>
